import React, { useState, useEffect } from 'react';
import { message, Form, InputNumber } from 'antd';
import Card, { CardEdit } from 'components/Card/Card';
import { useEditCard } from 'components/Card/useEditCard';
import TabularList from 'components/TabularList/TabularList';
import UploadFile from 'components/UploadFile/UploadFile';
import providerService, { PROVIDER_FILE_TYPES } from 'services/providers.service';
import { PROVIDER_APPLICATION_PROGRAM_TYPES } from 'containers/Provider/SelectProgram/SelectProgram';
import { EMDASH } from 'constants';

const Rates = ({ application, applicationFiles, setApplicationFiles, isEditable = false }) => {
  const ratesFiles = applicationFiles?.filter((f) => f.fileType === PROVIDER_FILE_TYPES.RATE_SHEET.code) || [];
  const [localApplication, setLocalApplication] = useState(application);
  const [ratesForm] = Form.useForm();

  useEffect(() => {
    setLocalApplication(application);
  }, [application]);

  const { isEditing, editProps } = useEditCard({
    id: 'rates',
    onEditStart: () => {
      ratesForm.setFieldsValue({
        respiteRate: localApplication?.respiteRate,
      });
    },
    onSave: async () => {
      await ratesForm.validateFields();
      const values = ratesForm.getFieldsValue();

      // Update application if respite rate changed
      if (
        PROVIDER_APPLICATION_PROGRAM_TYPES.ARMY_RESPITE.id === application?.programType.id &&
        values.respiteRate !== localApplication?.respiteRate
      ) {
        const updatedApplication = await providerService.updateApplication(application.id, {
          ...localApplication,
          respiteRate: values.respiteRate,
        });
        setLocalApplication(updatedApplication);
      }

      ratesForm.resetFields();
      message.success('Rates updated');
    },
    onDiscard: () => {
      ratesForm.resetFields();
    },
  });

  return (
    <Card title="Rates" extra={isEditable ? <CardEdit {...editProps} /> : null} noBodyPadding stickyHeader>
      <Form form={ratesForm} disabled={editProps.loading}>
        <TabularList
          indented
          data={[
            ...(PROVIDER_APPLICATION_PROGRAM_TYPES.ARMY_RESPITE.id === application?.programType.id
              ? [
                  {
                    title: 'Hourly rate per child',
                    value: isEditing ? (
                      <Form.Item
                        name="respiteRate"
                        className="mb-0"
                        rules={[{ required: true, message: 'Hourly rate is required' }]}
                      >
                        <InputNumber controls={false} prefix="$" className="w-full max-w-48" />
                      </Form.Item>
                    ) : typeof localApplication?.respiteRate === 'number' ? (
                      `$${localApplication?.respiteRate}`
                    ) : (
                      EMDASH
                    ),
                    titleRequired: true,
                  },
                ]
              : []),
            {
              title: 'Rate sheet',
              titleRequired: true,
              value: (
                <UploadFile
                  fileCode={PROVIDER_FILE_TYPES.RATE_SHEET.code}
                  files={ratesFiles}
                  setFiles={setApplicationFiles}
                  applicationId={application?.id}
                  readOnly={!isEditable}
                />
              ),
            },
          ]}
        />
      </Form>
    </Card>
  );
};

export default Rates;
